import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import Map, {Marker, NavigationControl, Popup} from 'react-map-gl/maplibre';
import 'maplibre-gl/dist/maplibre-gl.css';
import Constants from '../../utils/constants';
import DashboardCriteriaMapContainer from './DashboardCriteriaMapContainer';

export const DashboardMapComponent = ({markers, viewMode, initLocation, style, onSelectedTypesChange}) => {
    const zoomLevelInit = markers.length === 0 ? 5.5 : 10;
    const [zoomLevel, setZoomLevel] = useState(zoomLevelInit);
    const mapRef = useRef(null);
    const [hoveredMarker, setHoveredMarker] = useState(null);

    useEffect(() => {
        if (mapRef.current) {
            mapRef.current.setCenter([initLocation[1], initLocation[0]]);
        }
    }, [initLocation]);

    useEffect(() => {}, [zoomLevel, markers]);

    const handleZoomChange = (event) => {
        const newZoomLevel = event.viewState.zoom;
        setZoomLevel(newZoomLevel);
    };

    const distanceToleranceByZoomLevel = () => {
        if (zoomLevel < 4) {
            return 0.3;
        } else if (zoomLevel >= 4 && zoomLevel < 6) {
            return 0.15;
        } else if (zoomLevel >= 6 && zoomLevel < 8) {
            return 0.05;
        } else if ((zoomLevel) >= 8 && zoomLevel < 10) {
            return 0.01;
        } else if (zoomLevel >= 10 && zoomLevel < 11) {
            return 0.005;
        } else if (zoomLevel >= 11 && zoomLevel < 13) {
            return 0.002;
        } else if (zoomLevel >= 13 && zoomLevel < 15) {
            return 0.0005;
        } else if (zoomLevel >= 15 && zoomLevel < 19) {
            return 0.0001;
        } else if (zoomLevel >= 15 && zoomLevel < 25) {
            return 0.00005;
        }
        return 0.01;
    };

    const handleMouseMove = (event) => {
        const {lat, lng} = event.lngLat;
        const markerUnderCursor = markers.find((marker) => {
            const distance = Math.sqrt(Math.pow(marker.longitude - lng, 2) + Math.pow(marker.latitude - lat, 2));

            return distance < distanceToleranceByZoomLevel();
        });
        if (markerUnderCursor) {
            setHoveredMarker(markerUnderCursor);
        } else {
            setHoveredMarker(null);
        }
    };

    const getAddress = (address) => {
        return (
            <div className='row'>
                {address.city && (
                    <div className='col-12'>
                        <strong>Miasto: </strong>
                        {address.city}
                    </div>
                )}
                {address.streetName && (
                    <div className='col-12'>
                        <strong>Ulica: </strong>
                        {address.streetName}
                    </div>
                )}
                {address.streetNumber && (
                    <div className='col-12'>
                        <strong>Numer budynku: </strong>
                        {address.streetNumber}
                    </div>
                )}
                {address.postalCode && (
                    <div className='col-12'>
                        <strong>Kod pocztowy: </strong>
                        {address.postalCode}
                    </div>
                )}
            </div>
        );
    };

   const getLocation = (hoveredMarker) => {
    const {longitude, latitude} =  hoveredMarker;

    return  <div className='row'>
      {longitude && <div className='col-12'>
        <strong>Długość geograficzna: </strong>{longitude.toFixed(6)}</div>}  
      {latitude && <div className='col-12'> <strong>Szerokość geograficzna: </strong> {latitude.toFixed(6)}</div>}  
    </div>
   }

    const getHoveredText = () => {
        const address = hoveredMarker.address;
        return (
            <div className='row'>
                <div className='col-12'>{getAddress(address)}</div>
                <div className='col-12'>{getLocation(hoveredMarker)}</div>
            </div>
        );
    };

    return (
        <div className='row'>
            <div className={'col-12'}>
                <Map
                    className={'dashboard-map'}
                    ref={mapRef}
                    initialViewState={{
                        longitude: initLocation[1],
                        latitude: initLocation[0],
                        zoom: zoomLevel,
                    }}
                    onMouseMove={handleMouseMove}
                    onZoom={handleZoomChange}
                    style={style}
                    mapStyle={process.env.REACT_APP_MAPLIBRE_MAP_STYLE}
                >
                    <DashboardCriteriaMapContainer onValueChange={onSelectedTypesChange} />
                    <NavigationControl position='top-right' />
                    {markers.map((marker, index) => {
                        return (
                            <React.Fragment key={index}>
                                <Marker
                                    icon={''}
                                    key={index}
                                    longitude={marker.longitude}
                                    latitude={marker.latitude}
                                    draggable={viewMode !== 'VIEW'}
                                >
                                    <i
                                        className={`mdi ${marker.icon} icon-map-marker`}
                                        style={{
                                            fontSize: '16px',
                                            color: `${marker.color}`,
                                        }}
                                    />
                                </Marker>
                            </React.Fragment>
                        );
                    })}
                    {hoveredMarker && (
                        <Popup
                            longitude={hoveredMarker.longitude}
                            latitude={hoveredMarker.latitude}
                            closeButton={false}
                            closeOnClick={false}
                        >
                            <div>
                                <h6> {hoveredMarker.name} </h6>
                                {hoveredMarker.phoneNumber && <h7> {hoveredMarker.name} </h7>}   
                                <p>{getHoveredText()}</p>
                            </div>
                        </Popup>
                    )}
                </Map>
            </div>
        </div>
    );
};

DashboardMapComponent.defaultProps = {
    viewMode: 'VIEW',
    locations: [],
    style: {width: '100%', height: '700px', zIndex: '100'},
    showAddressPanel: false,
    initLocation: Constants.POLAND_LOCATION,
};

DashboardMapComponent.propTypes = {
    viewMode: PropTypes.string,
    initLocation: PropTypes.array,
    showAddressPanel: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    onSelectedTypesChange: PropTypes.func.isRequired,
    style: PropTypes.object,
    locations: PropTypes.array,
};

export default DashboardMapComponent;
